import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  class: "pagination _board_type",
  id: "list_paginate"
}
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: _normalizeClass(["first_btn icon_wrap", { on: $props.currentPage > 1 }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => ($props.currentPage > 1 && $setup.fnPaging(1)))
    }, _cache[4] || (_cache[4] = [
      _createElementVNode("img", {
        src: "img/board_first_btn.png",
        alt: "처음"
      }, null, -1)
    ]), 2),
    _createElementVNode("button", {
      class: _normalizeClass(["prev_btn icon_wrap", { on: $props.currentPage > 1 }]),
      onClick: _cache[1] || (_cache[1] = ($event: any) => ($props.currentPage > 1 && $setup.fnPaging($props.currentPage - 1)))
    }, _cache[5] || (_cache[5] = [
      _createElementVNode("img", {
        src: "img/board_prev_btn.png",
        alt: "이전"
      }, null, -1)
    ]), 2),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.visiblePages, (page) => {
      return (_openBlock(), _createElementBlock("button", {
        key: page,
        onClick: ($event: any) => ($setup.fnPaging(page)),
        class: _normalizeClass(["pg_btn", { active: page === $props.currentPage }])
      }, _toDisplayString(page), 11, _hoisted_2))
    }), 128)),
    _createElementVNode("button", {
      class: _normalizeClass(["next_btn icon_wrap", { on: $props.currentPage < $setup.paging }]),
      onClick: _cache[2] || (_cache[2] = ($event: any) => ($props.currentPage < $setup.paging && $setup.fnPaging($props.currentPage + 1)))
    }, _cache[6] || (_cache[6] = [
      _createElementVNode("img", {
        src: "img/board_prev_btn.png",
        alt: "다음"
      }, null, -1)
    ]), 2),
    _createElementVNode("button", {
      class: _normalizeClass(["last_btn icon_wrap", { on: $props.currentPage < $setup.paging }]),
      onClick: _cache[3] || (_cache[3] = ($event: any) => ($props.currentPage < $setup.paging && $setup.fnPaging($setup.paging)))
    }, _cache[7] || (_cache[7] = [
      _createElementVNode("img", {
        src: "img/board_first_btn.png",
        alt: "마지막"
      }, null, -1)
    ]), 2)
  ]))
}